import { SET_CUSTOM_FIELD_10 } from 'actions';

export function setCustomField10(sourceType: string) {
  return { sourceType, type: SET_CUSTOM_FIELD_10 };
}
